import { Box, Text } from '@wix/design-system';
import { CycleUtils } from '@wix/package-picker-shared';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';

export const BrazilCyclePrice = ({
  productId,
  cycle,
}: {
  productId: string;
  cycle: PurchaseOffering.PurchaseCycle;
}) => {
  const { t } = StudioPackagePickerModule.internals.useTranslations();

  const { data: product } =
    StudioPackagePickerModule.SDK.studioOfferingApiClient.hooks.useFetchProduct(
      { productId },
      Boolean(productId),
    );

  const { pricingDetails } = product ?? {};

  const pricingDetail = pricingDetails?.find(
    (d) =>
      d.cycle &&
      CycleUtils.convertCycleToCycleId(d.cycle) ===
        CycleUtils.convertCycleToCycleId(cycle),
  );

  const cycleLength = CycleUtils.convertCycleDurationToMonths(cycle);

  return (
    <Box direction="vertical">
      {pricingDetail?.catalogPrice?.subtotal?.formattedAmount && (
        <Text>
          {t('cycle_entry.cycle_price.in_cash', {
            fullPrice: pricingDetail.catalogPrice.subtotal.formattedAmount,
          })}
        </Text>
      )}
      {pricingDetail?.catalogPrice?.monthlyTotal?.formattedAmount && (
        <Text>
          {t('cycle_entry.cycle_price.br', {
            price: pricingDetail.catalogPrice.monthlyTotal.formattedAmount,
            cycleLength,
          })}
        </Text>
      )}
    </Box>
  );
};
